import React, { useEffect, lazy, Suspense } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
  Redirect,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/store";
import TagManager from 'react-gtm-module'

import Main from "./components/Home/mainLogin";
// import Login from "./screens/Login";
// import SignUp from "./screens/SignUp";
// import CheckoutPage from "./screens/Checkout"
// import AccountAuth from './screens/AccountAuth'
import Location from "./screens/Checkout"
import Payment from "./screens/Payment"
import Profile from "./screens/Profile";
import NewForgot from "./screens/OtpPassword";
// import RestuarantLoc from "./screens/RestuarantLocator";
import TrackOrder from "./screens/TrackOrder";
import CustomerComplaint from "./screens/CustomerComplaint";
// import Aboutus from "./screens/Aboutus";
import Terms from "./screens/Terms"
import MailingList from './screens/NewsLetterMails'
import confirmLocation from "./components/Checkout/confirmLocation";
import HomeLogin from "./components/HomeLogin/HomeLogin";
import Aboutus from "./screens/Aboutus";
import AccountAuth from "./screens/AccountAuth";
import Cart from "./screens/Cart";
import RestuarantLocator from "./screens/RestuarantLocator";
import Landing from "./screens/Landing";
import NutritionalInfo from "./screens/NutritionalInfo";
import page404 from "./screens/page404";
import CookiePolicy from "./screens/Cookie";
import UseTrackEvent from "./hooks/useTrackHook";
import CookieConsent from "./components/CookieConsent";
const Home = lazy(() => import('./screens/Home'));
const lang = localStorage.getItem("lang") || "en";
const tagManagerArgs = {
  gtmId: 'GTM-NQZ7ZPV2'
}
function App() {
  let location = useLocation()
  let windowObj = (window as any)
  windowObj.dataLayer.push({
      event: 'pageview',
      url:location
    });
useEffect(() => {
  TagManager.initialize(tagManagerArgs)
}, [location])

 useEffect(() => {
   const pathLang = location.pathname.split("/")[1]; // Get the lang from URL
   const currentLang = localStorage.getItem("lang");

   if ((pathLang === "en" || pathLang === "ar") && pathLang !== currentLang) {
     localStorage.setItem("lang", pathLang);
     window.location.reload(); // Force reload if lang changed
   }
 }, [location]);
  return (
    <Provider store={store}>
      <UseTrackEvent location={location} setAddEvent={() => {}} />
      {/* <CookieConsent/> */}
      <Suspense fallback={<div></div>}>
        <Switch>
          <Redirect exact from="/" to={`/${lang}`} />
          <Route exact path="/:lang/menu" component={Home} />
          <Route
            exact
            path="/:lang/menu"
            render={() => <Redirect to="/menu" />}
          />
          <Route exact path="/:lang/cart" component={Cart} />
          <Route exact path="/:lang/profile" component={Profile} />
          <Route exact path="/:lang/checkout/contact" component={AccountAuth} />
          <Route exact path="/:lang/checkout/location" component={Location} />
          <Route exact path="/:lang/checkout/payment" component={Payment} />
          <Route
            exact
            path="/:lang/locations-overview"
            component={RestuarantLocator}
          />
          <Route exact path="/:lang/track-order" component={TrackOrder} />
          <Route exact path="/:lang/feedback" component={CustomerComplaint} />
          <Route exact path="/:lang/reset-password" component={NewForgot} />
          <Route exact path="/:lang/our-story" component={Aboutus} />
          <Route exact path="/:lang/privacy-policy" component={Terms} />
          <Route exact path="/:lang/cookie-policy" component={CookiePolicy} />
          <Route exact path="/:lang/mailing-list" component={MailingList} />
          <Route
            exact
            path="/:lang/nutritional-info"
            component={NutritionalInfo}
          />
          <Route exact path="/:lang" component={Landing} />
          <Route path="*" exact component={page404} />
        </Switch>
      </Suspense>
    </Provider>
  );
}

export default App;
